// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.collapse__panel {
  transition: height 200ms ease, border-color 200ms ease;
}
.collapse__content {
  display: grid;
  min-height: 0;
  grid-template-rows: 1fr;
}
.collapse__content--with-transition {
  transition: grid-template-rows 250ms ease;
}
.collapse__content--state-entering {
  grid-template-rows: 1fr;
}
.collapse__content--state-entered {
  display: grid;
}
.collapse__content--state-exiting {
  grid-template-rows: 0fr;
}
.collapse__content--state-exited {
  display: none;
}
.collapse__content > div {
  overflow: hidden;
}
.collapse__toggle {
  text-align: start;
}
.collapse__toggle--full-width:hover {
  background-color: inherit;
}
.collapse__toggle:focus {
  outline: none;
}
.collapse__chevron {
  transition: transform 0.2s;
}
.collapse__chevron--collapsed {
  transform: rotate(-90deg);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/collapse/Collapse.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,sDAAA;AAQJ;AAHE;EACE,aAAA;EACA,aAAA;EACA,uBAAA;AAKJ;AAHI;EACE,yCAAA;AAKN;AAFI;EACE,uBAAA;AAIN;AADI;EACE,aAAA;AAGN;AAAI;EACE,uBAAA;AAEN;AACI;EACE,aAAA;AACN;AAvBE;EA0BI,gBAAA;AAAN;AAIE;EACE,iBAAA;AAFJ;AAKM;EACE,yBAAA;AAHR;AAOI;EACE,aAAA;AALN;AASE;EACE,0BAAA;AAPJ;AASI;EACE,yBAAA;AAPN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.collapse {\n  &__panel {\n    transition:\n      height 200ms ease,\n      border-color 200ms ease;\n  }\n\n  &__content {\n    display: grid;\n    min-height: 0;\n    grid-template-rows: 1fr;\n\n    &--with-transition {\n      transition: grid-template-rows 250ms ease;\n    }\n\n    &--state-entering {\n      grid-template-rows: 1fr;\n    }\n\n    &--state-entered {\n      display: grid;\n    }\n\n    &--state-exiting {\n      grid-template-rows: 0fr;\n    }\n\n    &--state-exited {\n      display: none;\n    }\n\n    > div {\n      overflow: hidden;\n    }\n  }\n\n  &__toggle {\n    text-align: start;\n\n    &--full-width {\n      &:hover {\n        background-color: inherit;\n      }\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  &__chevron {\n    transition: transform 0.2s;\n\n    &--collapsed {\n      transform: rotate(-90deg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
